import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import growbag_shop1 from "../../Assets/growbag_shop1.webp";
import growbag_shop2 from "../../Assets/growbag_shop2.webp";
import growbag_shop3 from "../../Assets/growbag_shop3.webp";
import growbag_shop4 from "../../Assets/growbag_shop4.webp";
import "bootstrap/dist/css/bootstrap.min.css";
import { Tab, Nav, Carousel } from "react-bootstrap";
import "../../App.css";

const Grow_bag_shop = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 60,
      name: "Oasis Cube",
      price: 250,
      image: growbag_shop1,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      <div className="row">
        <div className="col-md-6">
          <Carousel>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={growbag_shop1}
                alt="Grow bag shop"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={growbag_shop2}
                alt="grow bags"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={growbag_shop3}
                alt="grow bags for hydroponics"
              />
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="d-block w-100"
                src={growbag_shop4}
                alt="grow bag"
              />
            </Carousel.Item>
          </Carousel>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Grow Bag</h2>
            <p className="product-price">
              <a href="/Contact" className="btn btn-link">
                Contact Us for Price Details
              </a>
            </p>

            {/* <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button> */}

            <div className="row mt-4">
              <div className="col-12">
                <p className="text-justify">
                  <h4>Durable, Flexible & Cost-Effective Growing Container</h4>
                  These high-quality UV-stabilized grow bags are ideal for
                  hydroponic farming, greenhouse cultivation, rooftop gardening,
                  and commercial plant production. Made from premium-grade
                  plastic with a black inner and white outer layer, they ensure
                  temperature regulation and root protection, resulting in
                  healthy and productive plants.
                </p>
                <i>Note: Minimum Order Quantity: 100 Units</i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs Section with Border */}
      <div className="row mt-4">
        <div className="col-12 border-tabs">
          <Tab.Container defaultActiveKey="Specifications">
            <Nav variant="tabs" className="mb-3 custom-nav">
              <Nav.Item>
                <Nav.Link eventKey="Specifications" className="custom-tab">
                  Product Specifications
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="Features" className="custom-tab">
                  Features
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="moreInfo" className="custom-tab">
                  Additional Information
                </Nav.Link>
              </Nav.Item>
            </Nav>

            <Tab.Content>
              <Tab.Pane eventKey="Specifications">
                <ul>
                  <li>
                    <span className="fw-bold">Material:</span> UV-stabilized
                    multilayer LDPE plastic
                  </li>
                  <li>
                    <span className="fw-bold">Color:</span> White exterior
                    (reflects sunlight) and black interior (prevents root
                    exposure to light)
                  </li>
                  <li>
                    <span className="fw-bold">Thickness:</span> 300–500 microns
                    (customizable)
                  </li>
                  <li>
                    <span className="fw-bold">Drainage Holes:</span> Pre-punched
                    at the bottom for excess water release
                  </li>
                  <li>
                    <span className="fw-bold">Durability:</span> Designed for
                    3–5 years of continuous use
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="Features">
                <h4>Features</h4>
                <ul>
                  <li>
                    Scalable: Supports both small kitchen gardens and large
                    commercial farms
                  </li>
                  <li>
                    Water Efficient: Prevents overwatering through smart
                    drainage design
                  </li>
                  <li>
                    Clean & Soil-Free: Works with cocopeat, vermicompost, or
                    other soilless media
                  </li>
                  <li>
                    High Strength: Resistant to UV rays, heat, and weather
                    fluctuations
                  </li>
                  <li>
                    Eco-Friendly Disposal: Decomposes slowly without
                    contaminating the environment
                  </li>
                </ul>
              </Tab.Pane>

              <Tab.Pane eventKey="moreInfo">
                <h4>Additional Information</h4>
                <ul>
                  <li>
                    <span className="fw-bold">Item Code:</span> RGCPL-0037
                  </li>
                  <li>
                    <span className="fw-bold">Delivery Time:</span> 7-8 Days
                  </li>
                  <li>
                    <span className="fw-bold">Port of Dispatch:</span>{" "}
                    Maharashtra, India
                  </li>
                  <li>
                    <span className="fw-bold">Production Capacity:</span> 5,000
                    Bags Per Day
                  </li>
                  <li>
                    <span className="fw-bold">Packaging Details:</span> Bundled
                    or boxed as per client specifications
                  </li>
                  <li>
                    <span className="fw-bold">Payment Terms:</span> Advance
                    Payment
                  </li>
                  <li>
                    <span className="fw-bold">Payment Mode:</span> RTGS / NEFT /
                    IMPS
                  </li>
                </ul>
              </Tab.Pane>
            </Tab.Content>
          </Tab.Container>
        </div>

        <h5 className="mt-3">Key Benefits:</h5>
        <ul>
          <li>
            Root Zone Protection: Black inside layer prevents algae and root
            stress from light exposure
          </li>

          <li>
            Temperature Management: White outer surface reflects heat and helps
            maintain cool root zones
          </li>

          <li>
            Space Efficient: Great for vertical and horizontal arrangements in
            greenhouses or rooftops
          </li>

          <li>
            Reusable & Easy to Handle: Lightweight, foldable, and easy to move
            or replace
          </li>

          <li>
            Low-Cost Growing Solution: Ideal for commercial-scale operations and
            individual growers alike
          </li>
        </ul>

        <h5 className="mt-3">Applications:</h5>
        <ul>
          <li>Commercial hydroponic farms</li>

          <li>Polyhouse and shade net house cultivation</li>

          <li>Rooftop & terrace gardens</li>

          <li>Vertical growing systems</li>

          <li>Horticulture and floriculture nurseries</li>

          <li>Urban agriculture and DIY grow-at-home kits</li>
        </ul>
      </div>

      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Grow_bag_shop;
